// cheque summary donut chart data transformation utility
export interface DonutDataType {
    name: string;
    value: number;
    color: string;
}

const CHEQUE_COLORS: Record<string, string> = {
    Cleared: "#5DADE2",
    Bounced: "#E5A04B",
    Overdue: "#58D68D",
    Pending: "#EC7063",
};

export const transformChequeSummary = (summary: Record<string, number> | null): DonutDataType[] => {
    if (!summary) return [];
    // Normalize keys to match color mapping
    return Object.entries(summary).map(([key, value]) => ({
        name: key.charAt(0).toUpperCase() + key.slice(1).toLowerCase(), // "CLEARED" or "Cleared" -> "Cleared"
        value,
        color: CHEQUE_COLORS[key.charAt(0).toUpperCase() + key.slice(1).toLowerCase()] ?? "#ccc",
    }));
};

// monthly stock chart data transformation utility
const MONTHS = [
  { name: "Jan", fill: "#2c4c7c" },
  { name: "Feb", fill: "#e6953b" },
  { name: "Mar", fill: "#58a55c" },
  { name: "Apr", fill: "#ef7d3b" },
  { name: "May", fill: "#4c9a9a" },
  { name: "Jun", fill: "#e55353" },
  { name: "Jul", fill: "#2c4c7c" },
  { name: "Aug", fill: "#e6953b" },
  { name: "Sep", fill: "#58a55c" },
  { name: "Oct", fill: "#ef7d3b" },
  { name: "Nov", fill: "#4c9a9a" },
  { name: "Dec", fill: "#e55353" },
];

interface MonthlyDataType {
  month: string;
  value: number;
  fill: string;
}

export const transformMonthlySummary = (
  summary: Record<string, number> | null
): MonthlyDataType[] => {
  if (!summary) return [];

  return MONTHS.map((m, index) => ({
    month: m.name,
    value: summary[(index + 1).toString()] ?? 0, // "1", "2", ...
    fill: m.fill,
  }));
};